/**
 * Constants, string dictionaries, and validation messages for ServiciosOperativosModalComponent.
 */

export const OPERATIONAL_SERVICES_MESSAGES = {
  // Snackbar validation messages
  noServiceSelectedForProvider:
    'Seleccione al menos un servicio para cambiar de proveedor',
  ssffCatalogBlocked:
    'Los servicios seleccionados pertenecen a un catálogo SSFF. Los servicios del catálogo solo pueden modificarse desde el file padre.',
  multipleProvidersSelected:
    'Debe seleccionar servicios con el mismo proveedor para cambiarlos en lote.',
  noEligibleServicesForOrder:
    'Seleccione al menos un servicio sin Orden de Servicio generada',
  noActivityIdentifier:
    'No se encontró el identificador de actividad para cargar los servicios operativos.',
  genericLoadError:
    'Error de comunicación al consultar los servicios operativos.',

  // Tooltips
  tooltipSsffBlocked:
    'No se puede cambiar proveedor: contiene servicios de catálogo SSFF (solo modificable desde el file padre)',
  tooltipMultipleProviders:
    'No se puede cambiar proveedor: los servicios seleccionados tienen proveedores distintos',
  tooltipChangeProviderDefault:
    'Asignar o cambiar proveedor para los servicios seleccionados',
  tooltipOrderGenerationAllHaveOrders:
    'Todos los servicios seleccionados ya tienen una Orden de Servicio generada',
  tooltipOrderGenerationDefault:
    'Crear Orden de Servicio para los servicios seleccionados',

  // Fallbacks
  defaultTitle: 'Servicio',
  defaultIcon: 'briefcase',
  unknownProvider: 'Proveedor desconocido',
} as const;
